<div class="select">
  <ng-content></ng-content>
</div>

